export const METRIC_COMPARISON_OPTIONS = [
    {
        label: '<',
        value: '<',
    },
    {
        label: '<=',
        value: '<=',
    },
    {
        label: '>',
        value: '>',
    },
    {
        label: '>=',
        value: '>=',
    },
    {
        label: '=',
        value: '===',
    },
];

export const DIMENSION_COMPARISON_OPTIONS = [
    {
        label: 'containing',
        value: 'IN',
    },
    {
        label: 'not containing',
        value: 'NIN',
    },
];
